import { WITHDRAW_EVENTS } from "@/events";
import { useEventListener, useDialogPortal, useDisconnectedTokenForm, useStakingPosition } from "@/hooks";
import Big from "big.js";

export function useWithdrawForm() {
    const { stakingPosition } = useStakingPosition();

    const {
        form,
        amount: withdrawAmount,
        amountError: withdrawAmountError,
        isAmountOverBalance,
        setMaxAmount,
        resetAmount,
    } = useDisconnectedTokenForm({
        maxValue: stakingPosition.stakedBalance,
    });

    const { openWithdrawTransactionDialog } = useDialogPortal();

    useEventListener(WITHDRAW_EVENTS.SUCCESS, resetAmount);

    const submitWithdraw = form.handleSubmit(() => {
        const payload = {
            withdrawAmount: Big(withdrawAmount.value).toFixed(6, 0),
        };
        openWithdrawTransactionDialog(payload);
    });

    return {
        withdrawAmount,
        withdrawAmountError,
        submitWithdraw,
        setMaxAmount,
        isAmountOverBalance,
    };
}
